import { Box, Flex, theme, useColorMode } from '@bnb-chain/space';
import { reportEvent } from '@bnb-chain/canonical-bridge-widget';
import { Fragment } from 'react';

import { env } from '@/core/configs/env';
import { BridgeLinkItem } from '@/core/components/ExternalBridgesPanel/BridgeLinkItem';

export const OP_BNB_BRIDGE_URL = 'https://opbnb-bridge.bnbchain.org/deposit';
export const GREENFIELD_BRIDGE_URL = 'https://greenfield.bnbchain.org/en/bridge?type=transfer-in';

const options = [
  {
    icon: `${env.ASSET_PREFIX}/images/bnb_blockchain.png`,
    name: 'Greenfield Bridge',
    description: 'Transfer between BSC & BNB Greenfield',
    url: GREENFIELD_BRIDGE_URL,
    eventId: 'click_bridge_Greenfield',
  },
  {
    icon: `${env.ASSET_PREFIX}/images/bnb_blockchain.png`,
    name: 'opBNB Bridge',
    description: 'Transfer between BSC & opBNB',
    url: OP_BNB_BRIDGE_URL,
    eventId: 'click_bridge_opBNB',
  },
];

export function ExternalBridgesPanel() {
  const { colorMode } = useColorMode();

  return (
    <Flex
      flexDir={'column'}
      mt={[theme.sizes['4'], theme.sizes['4'], theme.sizes['4'], 0]}
      pt={[theme.sizes['8'], theme.sizes['8'], theme.sizes['10'], 0]}
      gap={theme.sizes['3']}
      borderTop={{ base: `1px solid ${theme.colors[colorMode].border[3]}`, lg: 'none' }}
    >
      <Box
        display={['flex', 'flex', 'flex', 'none']}
        fontWeight={700}
        fontSize={theme.sizes['3.5']}
      >
        Transfer Tokens within BNB Chain Ecosystem
      </Box>
      <Flex
        p={[0, 0, 0, theme.sizes['6']]}
        bg={['none', 'none', 'none', theme.colors[colorMode].layer[2].default]}
        w={['100%', '100%', '100%', '384px']}
        gap={theme.sizes['3']}
        borderRadius={[theme.sizes['3'], theme.sizes['3'], theme.sizes['3'], theme.sizes['6']]}
        color={theme.colors[colorMode].text.primary}
        flexDir={'column'}
        boxShadow={{ base: 'none', lg: '0px 24px 64px 0px rgba(0, 0, 0, 0.48)' }}
      >
        {options.map((item, index) => {
          const onClick = () => {
            reportEvent({
              id: item.eventId,
            });
          };

          return (
            <Fragment key={index}>
              <BridgeLinkItem item={item} onClick={onClick} />
            </Fragment>
          );
        })}
      </Flex>
    </Flex>
  );
}
